import axios from 'axios';
import qs from 'querystring';
const Post = ({url, data, ContentType}) => {
    var CancelToken = axios.CancelToken;
    var source = CancelToken.source();
    var api = 'http://admin.fanmengit.com/api/' + url;
    let request = axios({
        method: "post",
        url: api,
        headers:{
            Accept: 'application/json',
            'Content-Type': ContentType
        },
      cancelToken: source.token,
        data: qs.stringify(data)
    })
    request.source = source
    return request
}

export default Post
